<template>
    <v-container fluid class="text-xs-center"> 
        <v-text-field
            v-model="searchedText"
            :placeholder="$t('labels.search')"
          ></v-text-field>
        <div class="results-count">{{researches.length}} {{$t('labels.results')}}<span v-if="searchedText!=''">, {{filteredResearches.length}} Corrispondenze</span></div>
        <v-layout row wrap justify-center :class="multiselect?'multiselecting':'not-multiselecting'">
            <v-flex xs12 md10>
                <v-card 
                    v-for="research in visibleResearches" :key="research.id" 
                    :class="selectedResearches.includes(research.id) ? 'selected' : ''"
                    @click="researchClicked(research)"
                >
                    <v-card-text>
                        <div class="card-checkbox" v-if="multiselect"><v-icon>check</v-icon></div>
                        <div class="inline-block" style="max-width: calc(100% - 70px);">
                            <strong >{{research.reference}} {{research.year}} {{research.abc}}</strong><br>
                            <span style="font-style:italic;">{{ research.full }}</span><br>

                            <v-chip class="continent" v-if="research.inAfrica">{{$t('labels.africa')}}</v-chip>
                            <v-chip class="continent" v-if="research.inAmerica">{{$t('labels.america')}}</v-chip>
                            <v-chip class="continent" v-if="research.inAsia">{{$t('labels.asia')}}</v-chip>
                            <v-chip class="continent" v-if="research.inAustralia">{{$t('labels.oceania')}}</v-chip>
                            <v-chip class="continent" v-if="research.inEurope">{{$t('labels.europe')}}</v-chip>

                            <v-chip class="anatomic-part" v-if="research.cranium">{{$t('labels.cranium')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.lowerJaw">{{$t('labels.lowerJaw')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.teeth">{{$t('labels.teeth')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.hyoid">{{$t('labels.hyoid')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.vertebrae">{{$t('labels.vertebrae')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.ribs">{{$t('labels.ribs')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.girdles">{{$t('labels.girdles')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.limbs">{{$t('labels.limbs')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.osteoderms">{{$t('labels.osteoderms')}}</v-chip>
                            <v-chip class="anatomic-part" v-if="research.shell">{{$t('labels.shell')}}</v-chip>

                            <v-chip class="variability" v-if="research.intraspecificVariation">{{$t('labels.intraspecificVariation')}}</v-chip>
                            <v-chip class="variability" v-if="research.ontogeneticVariation">{{$t('labels.ontogeneticVariation')}}</v-chip>
                            <v-chip class="variability" v-if="research.sexDim">{{$t('labels.sexDim')}}</v-chip>

                            <v-chip class="data-type" v-if="research.hasDescription">{{$t('labels.hasDescription')}}</v-chip>
                            <v-chip class="data-type" v-if="research.hasFigure">{{$t('labels.hasFigure')}}</v-chip>
                            <v-chip class="data-type" v-if="research.hasScoring">{{$t('labels.hasScoring')}}</v-chip>
                            <v-chip class="data-type" v-if="research.hasGeometricMorphology">{{$t('labels.hasGeometricMorphology')}}</v-chip>
                            <v-chip class="data-type" v-if="research.hasFiniteElementsAnalysis">{{$t('labels.hasFiniteElementsAnalysis')}}</v-chip>

                            <v-chip class="techniques" v-if="research.drySkeleton">{{$t('labels.drySkeleton')}}</v-chip>
                            <v-chip class="techniques" v-if="research.clearingAndStaining">{{$t('labels.clearingAndStaining')}}</v-chip>
                            <v-chip class="techniques" v-if="research.ctScan">{{$t('labels.ctScan')}}</v-chip>
                            <v-chip class="techniques" v-if="research.xRays">{{$t('labels.xRays')}}</v-chip>
                            <v-chip class="techniques" v-if="research.histological">{{$t('labels.histological')}}</v-chip>

                            <br>
                        </div>
                        <div class="card-chev" v-if="!multiselect"></div>
                    </v-card-text>
                </v-card>
                <v-btn v-show="filteredResearches.length>maxElements" @click="maxElements+=100" style="background:#4caf50;color:white;">
                    {{$t('labels.moreResults')}}...
                </v-btn>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="showDeletionDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.confirmDeletion')}}
                </v-card-title>
                <v-card-text>
                    {{$t('labels.reallyDelete')}} {{selectedResearches.length}} researches?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDeletionDialog = false"
                >
                    No
                </v-btn>
                <v-btn
                    color="red"
                    style="color:white"
                    text
                    @click="deleteResearches();showDeletionDialog = false"
                >
                    {{$t('labels.yesDelete')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="showFilterDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.advancedSearch')}}
                </v-card-title>
                <v-card-text>
                    <v-switch :label="$t('labels.newSpeciesDescribed')" v-model="filters.newSpeciesDescribed" hide-details></v-switch>
                    <br>
                    <h2 style="text-align:left;">{{$t('labels.continents')}}</h2>
                    
                    <v-switch :label="$t('labels.africa')" v-model="filters.inAfrica" color="success" hide-details></v-switch>
                    <v-switch :label="$t('labels.america')" v-model="filters.inAmerica" color="success" hide-details></v-switch>
                    <v-switch :label="$t('labels.asia')" v-model="filters.inAsia" color="success" hide-details></v-switch>
                    <v-switch :label="$t('labels.oceania')" v-model="filters.inAustralia" color="success" hide-details></v-switch>
                    <v-switch :label="$t('labels.europe')" v-model="filters.inEurope" color="success" hide-details></v-switch>
                    <br>
                    <h2 style="text-align:left;">{{$t('labels.anatomicParts')}}</h2>
                    <v-switch :label="$t('labels.cranium')" v-model="filters.cranium" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.lowerJaw')" v-model="filters.lowerJaw" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.teeth')" v-model="filters.teeth" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.hyoid')" v-model="filters.hyoid" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.vertebrae')" v-model="filters.vertebrae" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.ribs')" v-model="filters.ribs" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.girdles')" v-model="filters.girdles" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.limbs')" v-model="filters.limbs" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.osteoderms')" v-model="filters.osteoderms" color="info" hide-details></v-switch>
                    <v-switch :label="$t('labels.shell')" v-model="filters.shell" color="info" hide-details></v-switch>
                    <br>
                    <h2 style="text-align:left;">{{$t('labels.variability')}}</h2>

                    <v-switch :label="$t('labels.intraspecificVariation')" v-model="filters.intraspecificVariation" color="indigo" hide-details></v-switch>
                    <v-switch :label="$t('labels.ontogeneticVariation')" v-model="filters.ontogeneticVariation" color="indigo" hide-details></v-switch>
                    <v-switch :label="$t('labels.sexDim')" v-model="filters.sexDim" color="indigo" hide-details></v-switch>
                    <br>
                    <h2 style="text-align:left;">{{$t('labels.dataType')}}</h2>

                    <v-switch :label="$t('labels.hasDescription')" v-model="filters.hasDescription" color="error" hide-details></v-switch>
                    <v-switch :label="$t('labels.hasFigure')" v-model="filters.hasFigure" color="error" hide-details></v-switch>
                    <v-switch :label="$t('labels.hasScoring')" v-model="filters.hasScoring" color="error" hide-details></v-switch>
                    <v-switch :label="$t('labels.hasGeometricMorphology')" v-model="filters.hasGeometricMorphology" color="error" hide-details></v-switch>
                    <v-switch :label="$t('labels.hasFiniteElementsAnalysis')" v-model="filters.hasFiniteElementsAnalysis" color="error" hide-details></v-switch>

                    <br>
                    <h2 style="text-align:left;">{{$t('labels.techniques')}}</h2>
                    <v-switch :label="$t('labels.drySkeleton')" v-model="filters.drySkeleton" color="orange" hide-details></v-switch>
                    <v-switch :label="$t('labels.ctScan')" v-model="filters.ctScan" color="orange" hide-details></v-switch>
                    <v-switch :label="$t('labels.clearingAndStaining')" v-model="filters.clearingAndStaining" color="orange" hide-details></v-switch>
                    <v-switch :label="$t('labels.xRays')" v-model="filters.xRays" color="orange" hide-details></v-switch>
                    <v-switch :label="$t('labels.histological')" v-model="filters.histological" color="orange" hide-details></v-switch>
                    <br><br>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        style="color:white"
                        text
                        @click="showFilterDialog = false"
                    >
                        {{$t('labels.apply')}}
                    </v-btn>
                    <v-btn
                        text
                        @click="clearFilters();showFilterDialog = false"
                    >
                        {{$t('labels.removeFilters')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="bottom-bar-holder">
            <div class="bottom-bar">
                <v-layout
                    justify-center
                    style="padding:0"
                >         
                    <v-btn
                        color="white"
                        style="background:#212121;font-size:20px;float:right;"
                        @click.native="showFilterDialog=true"
                        flat
                    >
                        <span class="filters-count" v-if="appliedFiltersCount>0">{{ appliedFiltersCount }}</span>
                        <v-icon>filter_alt</v-icon>
                        &nbsp;&nbsp;{{$t('labels.filter')}}
                    </v-btn>
                    <v-btn
                        color="white"
                        style="background:#212121;font-size:20px;float:right;"
                        @click.native="selectedResearches=[];multiselect=!multiselect;showToast=true"
                        flat
                    >
                        <v-icon v-if="multiselect">deselect</v-icon>
                        <v-icon v-else>select_all</v-icon>
                        &nbsp;&nbsp;{{$t('labels.multipleSelection')}}
                    </v-btn>
                    <v-btn
                        color="white"
                        style="background:rgb(244, 67, 54);font-size:20px;float:right;"
                        flat
                        v-if="multiselect"
                        @click.native="showDeletionDialog=true"
                    >
                        <v-icon>delete</v-icon>&nbsp;&nbsp;{{$t('labels.deleteSelected')}}
                    </v-btn>
                    <v-btn
                        color="white"
                        style="background:#4caf50;font-size:20px;float:right;"
                        v-if="!multiselect"
                        @click.native="$router.push({name: 'researchAdd'})"
                        flat
                    >
                        <v-icon>add</v-icon>&nbsp;&nbsp;{{$t('views.ResearchAdd')}}
                    </v-btn>
                </v-layout>
            </div>
        </div>
        <v-snackbar v-model="showToast" top>
            {{$t('labels.multiselect')}} {{multiselect?$t('labels.activated'):$t('labels.deactivated')}}
        </v-snackbar>
        <v-snackbar v-model="deletedConfirmToast" top>
            {{$t('labels.confirmResearchesDeletion')}}
        </v-snackbar>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Researches',
    data: function(){
        return{
            searchedText: "",
            researches:[],
            selectedResearches:[],
            multiselect: false,
            showDeletionDialog:false,
            showFilterDialog:false,
            deletedConfirmToast:false,
            showToast: false,
            maxElements: 100,
            filters:{
                "inAfrica":false,
                "inAmerica":false, 
                "inAsia":false, 
                "inEurope":false, 
                "inAustralia":false, 
                "cranium":false, 
                "lowerJaw":false, 
                "teeth":false, 
                "hyoid":false, 
                "vertebrae":false, 
                "ribs":false, 
                "girdles":false, 
                "limbs":false, 
                "osteoderms":false, 
                "shell":false, 
                "intraspecificVariation":false, 
                "ontogeneticVariation":false, 
                "sexDim":false, 
                "hasDescription":false, 
                "hasFigure":false, 
                "hasScoring":false, 
                "hasGeometricMorphology":false, 
                "hasFiniteElementsAnalysis":false, 
                "drySkeleton":false, 
                "clearingAndStaining":false, 
                "ctScan":false, 
                "xRays":false, 
                "histological":false, 
                "newSpeciesDescribed":false
            },
        };
    },
    computed: {
        filteredResearches(){
            let vm = this;
            return vm.researches.filter(function(el){
                return (
                    (vm.filters.inAfrica?vm.filters.inAfrica==el.inAfrica:true) &&
                    (vm.filters.inAmerica?vm.filters.inAmerica==el.inAmerica:true) &&
                    (vm.filters.inAsia?vm.filters.inAsia==el.inAsia:true) &&
                    (vm.filters.inEurope?vm.filters.inEurope==el.inEurope:true) && 
                    (vm.filters.inAustralia?vm.filters.inAustralia==el.inAustralia:true) &&
                    (vm.filters.cranium?vm.filters.cranium==el.cranium:true) &&
                    (vm.filters.lowerJaw?vm.filters.lowerJaw==el.lowerJaw:true) &&
                    (vm.filters.teeth?vm.filters.teeth==el.teeth:true) &&
                    (vm.filters.hyoid?vm.filters.hyoid==el.hyoid:true) &&
                    (vm.filters.vertebrae?vm.filters.vertebrae==el.vertebrae:true) &&
                    (vm.filters.ribs?vm.filters.ribs==el.ribs:true) &&
                    (vm.filters.girdles?vm.filters.girdles==el.girdles:true) &&
                    (vm.filters.limbs?vm.filters.limbs==el.limbs:true) &&
                    (vm.filters.osteoderms?vm.filters.osteoderms==el.osteoderms:true) &&
                    (vm.filters.shell?vm.filters.shell==el.shell:true) &&
                    (vm.filters.intraspecificVariation?vm.filters.intraspecificVariation==el.intraspecificVariation:true) && 
                    (vm.filters.ontogeneticVariation?vm.filters.ontogeneticVariation==el.ontogeneticVariation:true) &&
                    (vm.filters.sexDim?vm.filters.sexDim==el.sexDim:true) &&
                    (vm.filters.hasDescription?vm.filters.hasDescription==el.hasDescription:true) &&
                    (vm.filters.hasFigure?vm.filters.hasFigure==el.hasFigure:true) &&
                    (vm.filters.hasScoring?vm.filters.hasScoring==el.hasScoring:true) &&
                    (vm.filters.hasGeometricMorphology?vm.filters.hasGeometricMorphology==el.hasGeometricMorphology:true) &&
                    (vm.filters.hasFiniteElementsAnalysis?vm.filters.hasFiniteElementsAnalysis==el.hasFiniteElementsAnalysis:true) &&
                    (vm.filters.drySkeleton?vm.filters.drySkeleton==el.drySkeleton:true) &&
                    (vm.filters.clearingAndStaining?vm.filters.clearingAndStaining==el.clearingAndStaining:true) &&
                    (vm.filters.ctScan?vm.filters.ctScan==el.ctScan:true) &&
                    (vm.filters.xRays?vm.filters.xRays==el.xRays:true) &&
                    (vm.filters.histological?vm.filters.histological==el.histological:true) &&
                    (vm.filters.newSpeciesDescribed?vm.filters.newSpeciesDescribed==el.newSpeciesDescribed:true) &&
                    (vm.searchedText.trim()=='' || JSON.stringify(el).toUpperCase().includes(vm.searchedText.toUpperCase()))
                );
            });
        },
        visibleResearches(){
            let vm = this;
            return vm.filteredResearches.slice(0, vm.maxElements);
        },
        appliedFiltersCount(){
            let vm = this;
            let count = 0;
            Object.keys(vm.filters).forEach(function(key) {
                if(vm.filters[key]){
                    count++;
                }
            });
            return count;
        },
    },
    mounted: function(){
        let vm = this;
        vm.getResearches();
    },
    methods:{
        clearFilters(){
            let vm = this;
            Object.keys(vm.filters).forEach(function(key) {
                vm.filters[key] = false;
            });
        },
        deleteResearches(){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "researches/delete.php",
                data: {
                    "researches":vm.selectedResearches
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.selectedResearches=[];
                    vm.getResearches();
                    vm.deletedConfirmToast = true;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        },
        researchClicked(research){
            let vm = this;
            if(vm.multiselect){
                if(vm.selectedResearches.includes(research.id)){
                    vm.selectedResearches.splice(vm.selectedResearches.indexOf(research.id),1);
                }
                else{
                    vm.selectedResearches.push(research.id);
                }
            }
            else{
                vm.$router.push({name: 'research', params:{researchId:research.id}});
            }
        },
        getResearches(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "researches/getCollection.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.researches = [];
                    vm.researches = response.data.resources;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        }
    }
}
</script>

